export const url = {
  GROW_URL:{
      HOME: '/',
      INDENT: '/indent',
      INDENT_FAVOURITE: '/employee/indent/favorite',
      SHARED_INDENT: '/employee/shared-indent',
      COMMENT: '/resources/comment',
      TRIPS: '/employee/trips/allocated',
      ASSIGNED: '/employee/trips/assigned',
      CONFIRMED: '/employee/trips/confirmed',
      LOADING: '/employee/trips/loading',
      INTRANSIT: '/employee/trips/intransit',
      UNLOADING: '/employee/trips/unloading',
      ADVANCE_PENDING: '/employee/trips/advance_pending',
      ADDITIONAL_ADVANCE: '/employee/trips/additional_advance',
      TRUCKS: '/trucks',
      CUSTOMER: '/employee/customer',
      CUSTOMER_SALES: '/employee/customer_sales',
      EXCEPTION_APPROVAL: '/employee/billing/approvals', 
      TRUCKS_UNLOADING: '/trucks/unloading',
      TRUCKS_INTRANSIT: '/trucks/intransit',
      EMPLOYEE_INDENT: '/employee/indent',
      EMPLOYEE_TRIP: '/employee/trip',
      EMPLOYEE_TRUCK: '/employee/truck',
      EMPLOYEE_LOGIN: '/employee/login',
      EMPLOYEE_PARTNER: '/employee/partner',
      EMPLOYEE_ORGANIZATION: '/employee/organization',
      CUSTOMERS: '/employee/customers',
      INDENT_EXPIRED: '/employee/indent/expired',
      PARTNER_SALES: '/employee/partner_sales',
      EMPLOYEE: '/employee'
    },
    REPORT_URL: {
      PARTNER_SALES: "https://app.powerbi.com/view?r=eyJrIjoiYTFjNDJkODktNzkzOS00ODE3LWJlNTgtMTkzYmVkNTc2Yzk1IiwidCI6Ijc2NzA4ZDI4LWNhNzYtNDBhNS05OWU4LWY5MzZlODZhN2MwYyIsImMiOjEwfQ%3D%3D&pageName=ReportSectiona5aafe7e459ecc7498cb",
      CUSTOMER_SALES: "https://app.powerbi.com/view?r=eyJrIjoiYTFjNDJkODktNzkzOS00ODE3LWJlNTgtMTkzYmVkNTc2Yzk1IiwidCI6Ijc2NzA4ZDI4LWNhNzYtNDBhNS05OWU4LWY5MzZlODZhN2MwYyIsImMiOjEwfQ%3D%3D&pageName=ReportSection0c5140605a0cc7819b22",
      OPERATIONS_URL: "https://app.powerbi.com/view?r=eyJrIjoiYTFjNDJkODktNzkzOS00ODE3LWJlNTgtMTkzYmVkNTc2Yzk1IiwidCI6Ijc2NzA4ZDI4LWNhNzYtNDBhNS05OWU4LWY5MzZlODZhN2MwYyIsImMiOjEwfQ%3D%3D&pageName=e11399c33346647cc1a1",
      WFH_OPERATIONS: "https://app.powerbi.com/view?r=eyJrIjoiYTFjNDJkODktNzkzOS00ODE3LWJlNTgtMTkzYmVkNTc2Yzk1IiwidCI6Ijc2NzA4ZDI4LWNhNzYtNDBhNS05OWU4LWY5MzZlODZhN2MwYyIsImMiOjEwfQ%3D%3D&pageName=30c05a15b85c5733b61c",
      DEFAULT: "https://app.powerbi.com/view?r=eyJrIjoiYTFjNDJkODktNzkzOS00ODE3LWJlNTgtMTkzYmVkNTc2Yzk1IiwidCI6Ijc2NzA4ZDI4LWNhNzYtNDBhNS05OWU4LWY5MzZlODZhN2MwYyIsImMiOjEwfQ%3D%3D",
    },
    ADD_ICON_URL: {
    'indent': '/employee/indent/create',
    'customer': '/employee/customer_sales/create_customer',
    'partner': '/employee/partner_sales/create_partner'
  },
  APP_VERSION_URL:{
    android: {
      latestVersionCode: 55,
      downloadUrl: "https://play.google.com/store/apps/details?id=in.fr8.grow",
    },
    ios: {
      latestVersionCode: 1,
      // TODO: swap <APP_STORE_ID> for the real numeric App Store id once the app is published
      // (App Store Connect shows it after the app record is created — see kafka/NOVU.md).
      downloadUrl: "https://apps.apple.com/app/id<APP_STORE_ID>",
    },
  },
  RECAPTCHA_VERIFY_URL: "https://www.google.com/recaptcha/api/siteverify",
  NEED_HELP_WIKI: 'https://wiki.fr8.in/wiki/how-to-login-wow'       , 
  TRACK_LOGIN_APPROVAL: `${import.meta.env.VITE_TRACK_URL}/approvals?tab=8`  ,
  WIKI_HELP_MENU : 'https://wiki.fr8.in/wiki'
}
